<template>
  <div class="layout-box">
    <LayoutHeader :headtitle="names"></LayoutHeader>
    <div class="secondary-content">
      <div class="reprint-box">
        <div class="rbox1" style="position: relative" v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.1)">
          <h3 style="position: absolute; top: 12px; left: 12px; font-size: 16px;">类别</h3>
          <div id="sentimentchartline" style="width: 100%; height: 100%">
            <span v-for="(itme,index) in typeList" :key="index" :title="'频次：'+itme.num">
              {{itme.nameStr}}
            </span>
          </div>
        </div>
        <div class="rbox2" style="position: relative" v-loading="loading1" element-loading-background="rgba(0, 0, 0, 0.1)">
          <h3 style="position: absolute; top: 12px; left: 12px; font-size: 16px;">价格周趋势</h3>
          <div id="sentimentchartline1" style="width: 100%; height: 100%"></div>
        </div>
      </div>
      <div class="reprint-box">
        <div class="rbox2" style="width: 49.75%;position: relative" v-loading="loading2" element-loading-background="rgba(0, 0, 0, 0.1)">
          <h3 style="position: absolute; top: 12px; left: 12px; font-size: 16px;">产品周效益</h3>
          <div id="sentimentchartline2" style="width: 100%; height: 100%"></div>
        </div>
        <div class="rbox1" style="width: 49.75%;position: relative" v-loading="loading3" element-loading-background="rgba(0, 0, 0, 0.1)">
          <h3 style="position: absolute; top: 12px; left: 12px; font-size: 16px;">负荷周趋势</h3>
          <div id="sentimentchartline3" style="width: 100%; height: 100%"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LayoutHeader from '../layout/layout-header2';
import {getTime} from '../../bll/utils'
const colors=[{name:'涤纶长丝',color:'#2E87FE'},{name:'涤纶短纤',color:'#6464DF'},{name:'锦纶',color:'#1DC5C0'},{name:'氨纶',color:'#ED7C31'},{name:'粘胶短纤',color:'#5AA0CF'}]
export default {
  name: 'SentimentAnalysis',
  props: {
    dataRefresh: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  components:{
    LayoutHeader
  },
  data () {
    return {
      names:'行业监测总览',
      loading:true,
      loading1:true,
      loading2:true,
      loading3:true,
      typeList:[]
    }
  },
  mounted () {
    const $this=this
    setTimeout(function () {
      $this.getdata()
    },500)
    $this.dataRefresh.$ons('Refresh', () => {
      $this.getdata()
    })
  },
  methods:{
    getdata(){
      const $this=this
      const url = '/api-portal/category/typeList';
      $this.$api.post(url, {}, (response) => {
        let datas=response.data||''
        if(datas){
          $this.typeList=datas.data
          this.loading=false
        }
      })
      const url2 = '/api-portal/category/weekPrive';
      $this.$api.post(url2, {}, (response) => {
        let datas=response.data||''
        if(datas){
          const datall=datas.data
          let time=datall.dataX
          let series=[]
          datall.dataY.forEach(val=>{
            const col=$this.getcolor(val.nameStr)
            const zj={
              name: val.nameStr,
              type: 'line',
              smooth: true,
              color: col,
              showSymbol: false,
              data:val.list
            }
            series.push(zj)
          })
          $this.Loadtrendline(series,time,'sentimentchartline1')
          this.loading1=false
        }
      })
      const url3 = '/api-portal/category/weekData';
      $this.$api.post(url3, {}, (response) => {
        let datas=response.data||''
        if(datas){
          const datall=datas.data
          let time=datall.dataX
          let series=[]
          datall.dataY.forEach(val=>{
            const col=$this.getcolor(val.nameStr)
            const zj={
              name: val.nameStr,
              type: 'bar',
              smooth: true,
              color: col,
              showSymbol: false,
              data:val.list
            }
            series.push(zj)
          })
          $this.Loadtrendline(series,time,'sentimentchartline2')
          this.loading2=false
        }
      })
      const url4 = '/api-portal/category/weekLoad';
      $this.$api.post(url4, {}, (response) => {
        let datas=response.data||''
        if(datas){
          const datall=datas.data
          let series=[]
          let time=[]
          datall.forEach((val,index)=>{
            val.list=val.list.map(item=>{
              if(index==0){
                time.push(item[0])
              }
              return item[1]
            })
            const col=$this.getcolor(val.nameStr)
            const zj={
              name: val.nameStr,
              type: 'line',
              smooth: true,
              color: col,
              areaStyle: {},
              showSymbol: false,
              data:val.list
            }
            series.push(zj)
          })
          $this.Loadtrendline(series,time,'sentimentchartline3')
          this.loading3=false
        }
      })
    },
    getcolor(name){
      return (colors[colors.findIndex((item) => item.name == name)] || {}).color || '#5AA0CF'
    },
    Loadtrendline(datall,t,obj){
      const myEchartst = this.$echarts.init(document.getElementById(obj))
      var st = t[t.length -49]
      var ed = t[t.length -1]
      let option = {
        tooltip: {
          trigger: 'axis',
        },
        legend: {
          show: true,
          left: 'center',
          top: 20,
          icon:'path://M128 432h768v192H128z',
          textStyle: {
            color: '#AAAAB0'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '12%',
          top: '14%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisLabel: {
            color: '#B6B6BB',
            // formatter: function (params) {
            //   return parseTime(params,'{y}-{m}-{d}')
            // }
          },
          axisLine:{
            lineStyle:{
              color:'#5788EC'
            }
          },
          data:t
        },
        yAxis: {
          type: 'value',
          boundaryGap: [0, '100%'],
          splitLine: {
            show:false,
          },
          max:function (value) {
            return parseInt((value.max+9)/10)*10
          },
          min:function (value) {
            return parseInt((value.min-2)/10)*10
          },
          axisLine:{
            show:true,
            lineStyle:{
              color:'#555656'
            }
          },
          axisLabel: {
            color: '#B6B6BB'
          }
        },
        dataZoom: [
          {
            type: 'slider',
            borderColor:'#000',
            backgroundColor: 'rgba(47,69,84,0.8)',
            startValue: st,
            endValue: ed
          }
        ],
        series: datall
      }
      myEchartst.setOption(option)
      this.loading2=false
    }
  }
}
</script>

<style scoped>
.layout-box {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 1;
  top:0;
  left: 0;
  background: #060614 url("../../assets/bjs.png") no-repeat top/100%;
}

.secondary-content{
  width: 100%;
  height: calc(100% - 20px);
  padding: 0 10px;
  padding-top: 152px;
  display: flex;
  box-sizing: border-box;
  justify-content: space-between;
  align-items: center;
  flex-direction:column;
  color: #fff;
}

.reprint-box{
  box-sizing: border-box;
  height: 49.43%;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.reprint-box>div{
  border: 1px solid #374E7F;
  box-sizing: border-box;
  height: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.rbox1{
  width: 40.5%;
}
.rbox2{
  width: 59%;
}

#sentimentchartline span{
  position: absolute;
  top: 50%;
  left: 50%;
  transition: color 1s linear;
  opacity: 0.8;
  cursor: pointer;
}

#sentimentchartline span:nth-child(1){
  font-size: 32px;
  color: #2E87FE;
  margin-left: -13%;
  margin-top: -2%;
}
#sentimentchartline span:nth-child(2){
  font-size: 26px;
  color: #6464DF;
  margin-left: 7%;
  margin-top: -2%;
}
#sentimentchartline span:nth-child(3){
  font-size: 21px;
  color: #1DC5C0;
  margin-left: 0%;
  margin-top: -5%;
}
#sentimentchartline span:nth-child(4){
  font-size: 18px;
  color: #ED7C31;
  margin-left: -11%;
  margin-top: 6%;
}
#sentimentchartline span:nth-child(5){
  font-size: 16px;
  color: #5AA0CF;
  margin-left: -12%;
  margin-top: -5%;
}
#sentimentchartline span:nth-child(6){
  font-size: 16px;
  color: #2E87FE;
  margin-left: -5%;
  margin-top: 5%;
}

#sentimentchartline span:hover{
  opacity: 1;
}

</style>



// WEBPACK FOOTER //
// src/views/secondary/sentiment-analysis.vue